export default function MitreAttackPage() {
  return (
    <div className="h-[96vh]">
      <iframe
        src="https://hackathon.bhumiitech.com/login"
        title="MITRE ATT&CK Automation"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        allow="same-origin"
      />
    </div>
  );
}
